import React from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';
import { useI18n } from '../../contexts/I18nContext';

interface GoogleButtonProps {
  onSuccess?: () => void;
}

const GoogleButton: React.FC<GoogleButtonProps> = ({ onSuccess }) => {
  const { user, loginWithGoogle, loading } = useAuth();
  const { t } = useI18n();
  const [error, setError] = React.useState<string | null>(null);
  const [showShine, setShowShine] = React.useState(false);

  const handleClick = async () => {
    setError(null);
    try {
      console.log('Abriendo selección de cuenta de Google...');
      
      // Abrir directamente la selección de Google sin verificar usuario autenticado
      // Firebase manejará la verificación de existencia de la cuenta
      await loginWithGoogle();
      onSuccess?.();
    } catch (e: any) {
      console.error('Error en vinculación con Google:', e);
      
      if (e?.message?.includes('account-exists-with-different-credential')) {
        setError('Esta cuenta de Google ya está vinculada a otro usuario.');
      } else if (e?.message?.includes('user-not-found')) {
        setError('Esta cuenta de Google no existe en nuestro sistema. Contacta para crear tu cuenta.');
      } else if (e?.message?.includes('invalid-credential')) {
        setError('Credenciales de Google inválidas. Intenta nuevamente.');
      } else if (e?.message?.includes('requires-recent-login')) {
        setError('Por seguridad, debes iniciar sesión nuevamente.');
      } else {
        setError(e?.message || 'Error al vincular cuenta con Google');
      }
    }
  };

  return (
    <div className="space-y-2">
      <motion.button
        type="button"
        onClick={handleClick}
        disabled={loading}
        whileTap={{ scale: 0.98 }}
        data-google-login
        className={`w-full bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 text-gray-800 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-slate-700 font-medium py-3 px-6 rounded-2xl transition-all duration-200 flex items-center justify-center space-x-3 relative overflow-hidden ${
          showShine ? 'animate-pulse' : ''
        }`}
      >
        {/* Efecto de brillo */}
        {showShine && (
          <motion.div
            initial={{ x: '-100%' }}
            animate={{ x: '100%' }}
            transition={{ duration: 1, ease: 'easeInOut' }}
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
          />
        )}
        <img src="https://www.gstatic.com/images/branding/product/1x/gsa_64dp.png" alt="Google" className="w-5 h-5" />
        <span>{loading ? t('loading') : 'Iniciar sesión con Google'}</span>
      </motion.button>
      {error && (
        <motion.div 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-sm text-red-600 dark:text-red-400 text-center"
        >
          {error}
        </motion.div>
      )}
    </div>
  );
};

export default GoogleButton;


